import { createAction } from '@reduxjs/toolkit';
import { INewsFeedPost } from '../newsFeedInterfaces';

export const updateNewsFeedPostAction = createAction<{ post: INewsFeedPost; access: string[]; accountNum: string }>(
  'UPDATE_NEWS_FEED_POST'
);
